export default function WelcomePage() {
  return (
    <div>
      <h1>Welcome to Childlight!</h1>
      <p>Please login on the top right to get started.</p>
    </div>
  );
}
